<template lang="pug">
div.loginOperation(v-show="!urlParams.token")
  div.loginpanel
    //- 身份选择
    ul.identityTab(v-if="identityList.length && !isJF")
      li(
        v-for="(item, index) in identityList" 
        :class="{active:identity === item}" 
        @click="changeIdentity(item)"
      ) {{ $t(`Login.loginBody.${identitystr}[${index}]`)}}
    //- 错误提示
    div.error-tip(v-if="!isJF" :style='{ opacity: errorText ? 1 : 0 }')
      div
        span.error-tip-text {{ errorText }}
        span.error-tip-text.red(@click="toggleFindPwd" v-show="identity ==='student' && isShow && !isJF") 忘记密码
    //- 用户名
    div.username
      km-input(
        ref="input_unsername" 
        v-model="username" 
        placeholder='请输入账号或手机号' 
        :autofocus="true" 
        @enter='handleLogin' 
        @change="clearErrorText")
        i.icon.icon_username(slot="icon")
    //- 密码
    div.password
      km-input(
        ref="input_password" 
        v-model="password" 
        style="marginTop:20px" 
        type="password" 
        placeholder='请输入密码' 
        @enter='handleLogin' 
        @input="clearErrorText")
        i.icon.icon_password(slot="icon")
    div(:class="{m30:identity !== 'student', operation:identity === 'student'}")
      span(@click="toggleFindPwd" v-show="identity==='student'") {{ $t('Login.loginBody.forgetPass') }}？
    div.submit
      button(@click='handleLogin') {{ $t('Login.loginBody.login') }}
    //- div.ext-info(v-if="identity ==='teacher'")
    //-   p
    //-     | 申请账号，请联系
    //-     span(@click="callOnlineService") 在线客服
    //- div.other_operation.flex-center-center(v-if="!isJF")
    //-   i.icon
    //-   span(@click="downloadAppByCode") {{$t('Login.loginBody.downloadQR')}}
    //-   span(@click="gotoRegister" v-if="!checkIsZhaoyang" v-show="identity==='student' && allowRegister") {{$t('Login.loginBody.register')}}
    //- 错误提示
    div.error-tip(v-if="isJF" :style='{ opacity: errorText ? 1 : 0 }')
      div
        span.error-tip-text {{ errorText }}
        span.error-tip-text.red(@click="toggleFindPwd" v-show="identity ==='student' && isShow") 忘记密码
  //- 二维码
  //- div.qrCode(v-if="!isJF" :class="{enter: showqrCode,leave: !showqrCode}" @mouseover='overShow' @mouseout='overHide')
  //-   img.studentApp(:src='stuQrcode')
  //-   p.mobile {{ $t('Login.loginBody.studentMobile') }}
  //-   img.teacherApp(:src='teaQrcode')
  //-   p.mobile {{ $t('Login.loginBody.teacherMobile') }}
</template>

<script>
import { readToken, unifyLogin, preLogin, tpreLogin, hpreLogin, confirgue } from '@/api'
import { $cookie, trim, getBrowserInfo } from '@/util/Util'

export default {
  name: 'Form',
  props: ['toggleFindPwd', 'ist2s', 'isJF'],
  data() {
    return {
      checkIsZhaoyang: window.ConfigNew.checkIsZhaoyang, // 朝阳去隐藏二维码
      urlParams: this.getUrlParam(),
      identityList: ['student', 'teacher', 'headmaster'],
      identity: 'student',
      errorText: '',
      showqrCode: false,
      username: '',
      password: '',
      clearSetTimeout: '',
      stuQrcode: '',
      teaQrcode: '',
      identitystr: this.ist2s ? 'tidentity' : 'identity',
      allowRegister: false,
      isShow: false
    }
  },
  methods: {
    callOnlineService() {
      document.querySelector('.onlineService.sidebarSection').click()
    },
    getUrlParam() {
      let urlP = {}
      if (location.search) {
        location.search
          .substring(1)
          .split('&')
          .forEach(item => {
            let _kv = item.split('=')
            urlP[_kv[0]] = _kv[1]
          })
      }
      return urlP
    },
    changeIdentity(type) {
      // 切换身份
      this.identity = type
      // if (type !== 'student' && this.errorText === '您输入的密码和账户名不匹配,是否') {
      //   this.errorText = '您输入的密码和账户名不匹配!'
      // }
    },
    handleTeaMenu(menu) {
      if (menu) {
        let arr = []
        menu.forEach(item => {
          arr.push({
            tag_action: item.tag_action,
            module: item.module,
            url: item.url,
            name: item.name
          })
        })
        $cookie.set('teaMenu', JSON.stringify(arr))
      }
    },
    doPreLogin(cb) {
      let { username, identity } = this
      let ploginFn =
        identity === 'headmaster'
          ? hpreLogin
          : identity === 'teacher'
          ? tpreLogin
          : preLogin
      username = trim(username)

      ploginFn({
        username
      }).then(res => {
        if (res.status === 1) {
          let data = res.data.CustomerInfo

          $cookie.set('hasZy', data.only_zy) // 仅作业
          $cookie.set('hasCp', data.only_cp) // 仅测评
          $cookie.set('model', data.to_b) // 1:2B else:2C 配置

          localStorage.setItem('cpUrl', data.cp_url)
          localStorage.setItem('zyUrl', data.zy_url)
          localStorage.setItem('mUrl', data.mobile_url)
          localStorage.setItem('accUrl', data.acc_url)
          localStorage.setItem('resUrl', data.resource_url + '/')
          localStorage.setItem('gatewayUrl', data.gatewayUrl)

          typeof cb === 'function' && cb()
        } else {
          this.isShow = false
          this.errorText = res.info

          if (this.urlParams.token) {
            alert(this.errorText)
          }
        }
      })
    },
    doLogin() {
      let { identity, username, password } = this
      username = trim(username)
      password = trim(password)

      unifyLogin({
        identity,
        username,
        password
      }).then(res => {
        if (res.status === 1) {
          localStorage.removeItem('stu_index_region') // 删除学生端听说考试、专项训练 地区保存的配置
          localStorage.removeItem('stu_index_grade') // 删除学生端听说考试、专项训练 地区保存的配置
          localStorage.setItem(
            'socketToken',
            new Date().getTime() + Math.random().toFixed(10)
          ) // websocket token
          if (this.urlParams.token) {
            $cookie.set('token', this.urlParams.token)
          } else {
            $cookie.set('identity', identity)
            $cookie.set('username', username)
            $cookie.set('password', password)
          }
          localStorage.setItem('isShowCorrectDialog', true)
          // 电教馆 评价举报用id
          localStorage.setItem(
            'djg-id',
            (identity === 'headmaster' ? 'mas' : identity.substring(0, 3)) + res.data.id
          )

          this.$store.username = username
          this.$store.password = password

          const { location } = window
          const { protocol, origin, hostname } = location
          const info = res.data
          const { relate_client, url } = info
          let _origin = origin
          let _host = 'kami' // 客户名称，例如：kami、jimei

          this.handleTeaMenu(info.menu)

          if (
            relate_client &&
            window.ConfigNew.doubleBrandWhiteList.indexOf(relate_client) > -1
          ) {
            _host = relate_client
            if (hostname.indexOf(relate_client) < 0) {
              // url中不包含客户
              const splitList = hostname.split('.')
              if (splitList.length < 3) {
                // 防止类似 http(s)://kamienglish.com 的域名
                splitList.unshift(relate_client)
              } else {
                splitList[0] = relate_client
              }
              _origin = protocol + '//' + splitList.join('.')
            }
          }

          $cookie.set('origin', _origin) // 用于测评系统返回二级域名（如果有）的作业系统
          $cookie.set('host', _host) // 用于测评系统获取二级logo（如果有）

          const browser = getBrowserInfo()
          const track = {
            accessToken: info.accessToken,
            customerInfoId: info.customerInfoId,
            userRoleType: info.user_role_type,
            clientVersion: info.clientVersion,
            serverVersion: info.serverVersion,
            userId: info.id,
            userName: username,
            fullName: encodeURIComponent(info.teacher_name || info.name),
            schoolId: info.school_id,
            categoryId: info.category_id,
            scId: info.school_class_id,
            actionOrigin: 1, // 动作来源 1.作业系统 2.测评系统 3内容系统 4.前端
            clientType: 1, // 客户端类型 0.未传或未知 1.Web 2.IOS 3.Android
            clientInfo: browser.name + ' ' + browser.version,
            loginFrom: 1,
            logType: 1 // 日期类型 1正常日志 0异常日志
          }

          localStorage.setItem('kami_track', JSON.stringify(track))
          // 判断是否来自教研平台
          if (this.ist2s) {
            localStorage.setItem('t2s', true)
          } else {
            localStorage.removeItem('t2s')
          }
          const status = +res.data.status
          // 未完善信息的学生
          if (status === 2) {
            this.$emit('perfectInfo', {
              type: 'perfectInfo',
              isPer: +res.data.regFrom === 7
            })
            return
          }
          // 未激活激活码
          if (status === 4) {
            this.$emit('next', res.data.username)
            return
          }
          // 被踢出班级的学生
          if (status === 5) {
            this.$emit('perfectInfo', {
              type: 'removeClass',
              isPer: +res.data.regFrom === 7
            })
            return
          }

          let href = ''
          if (identity === 'student') {
            href = _origin + '/stu'
          } else if (identity === 'teacher') {
            href = _origin + '/teacher'
          } else {
            href = _origin + '/web/' + url
          }
          location.href = href
        } else {
          this.errorText = res.info
          this.isShow = true
          console.log(this.urlParams.token)
          if (this.identity === 'student' && this.isShow) {
            this.errorText = '您输入的密码和账户名不匹配,是否'
          }
          if (this.urlParams.token) {
            alert(this.errorText.substr(0, this.errorText.length - 3))
          }
        }
      })
    },
    handleLogin() {
      let { username, password } = this
      username = trim(username)
      password = trim(password)

      if (!username && !password) {
        this.isShow = false
        this.errorText = '账户名和密码都不能为空!'
      } else if (!username) {
        this.isShow = false
        this.errorText = '账户名不能为空!'
      } else if (!password) {
        this.isShow = false
        this.errorText = '密码不能为空!'
      } else {
        this.errorText = ''
        // this.doPreLogin(this.doLogin)
        this.doLogin()
      }
      if (this.urlParams.token && this.errorText) {
        alert(this.errorText.substr(0, this.errorText.length - 3))
      }
    },
    downloadAppByCode() {
      this.showqrCode = !this.showqrCode
      this.clearSetTimeout = window.setTimeout(() => {
        window.clearTimeout(this.clearSetTimeout)
        if (this.showqrCode) {
          this.showqrCode = !this.showqrCode
        }
      }, 5000)
    },
    gotoRegister() {
      this.$emit('showRegister')
    },
    overShow() {
      this.showqrCode = true
      window.clearTimeout(this.clearSetTimeout)
    },
    overHide() {
      this.showqrCode = false
      window.clearTimeout(this.clearSetTimeout)
    },
    clearErrorText() {
      this.errorText = ''
    },
    getInfoByToken() {
      // 一键登录用
      readToken({
        token: this.urlParams.token
      }).then(res => {
        if (res.status === 1) {
          this.username = res.data.numberId
          this.password = res.data.password
          this.handleLogin()
        } else {
          alert(res.info)
        }
      })
    }
  },
  created() {
    if (this.ist2s) {
      this.identityList.length = 2
    }

    if (this.urlParams.token) {
      const identity = this.urlParams.identity
      this.identity = this.identityList.includes(identity) ? identity : 'student'
      this.getInfoByToken()
    } else if (!this.isJF) {
      const identity = $cookie.get('identity')
      this.identity = this.identityList.includes(identity) ? identity : 'student'
      this.username = $cookie.get('username') || ''
      this.password = $cookie.get('password') || ''
    }
  },
  mounted() {
    console.log(this.urlParams)
    this.$store.login = (username, password) => {
      if (username && password) {
        this.username = username
        this.password = password
      }
      this.handleLogin()
    }
    confirgue().then(res => {
      this.allowRegister = res.data.passport.allowRegister
    })
    this.downloadAppByCode() // 显示二维码

    // 二维码
    const { customer } = window.ConfigNew
    this.stuQrcode = `https://download.chivoxapp.com/assets/${customer}/qr-stu.png`
    this.teaQrcode = `https://download.chivoxapp.com/assets/${customer}/qr-tea.png`
  }
}
</script>

<style lang="less" scoped>
@import url('./Form.less');
.m30 {
  position: relative;
  text-align: right;
  margin-top: 39px !important;
}
.ext-info {
  p {
    line-height: 20px;
    margin: 10px auto;
    text-align: center;

    span {
      color: #21bd73;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/components/Form.vue